import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
import { ActionTypes } from "../../../../OrderFlow/OrderFlowProvider/OrderFlowActionTypes";
import { useOrderFlow } from "../../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
export const OrderSummaryEditContext = createContext({
    isEditMode: false,
    setIsEditMode: () => { },
    setMealsBeforeEditing: () => { },
    mealsBeforeEditing: undefined,
    setTemplateBeforeEditing: () => { },
    templateBeforeEditing: undefined,
    loading: false,
    setLoading: () => { },
    isCustomizeModalOpen: false,
    setIsCustomizeModalOpen: () => { },
    recipeId: undefined,
    setRecipeId: () => { },
    date: undefined,
    setDate: () => { },
    resetContext: () => { },
    resetMealsAndTemplate: () => { },
});
export const OrderSummaryEditContextProvider = ({ children }) => {
    const [mealsBeforeEditing, setMealsBeforeEditing] = useState(undefined);
    const [templateBeforeEditing, setTemplateBeforeEditing] = useState(undefined);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isCustomizeModalOpen, setIsCustomizeModalOpen] = useState(false);
    const [recipeId, setRecipeId] = useState(undefined);
    const [date, setDate] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const { dispatch } = useOrderFlow();
    const resetContext = () => {
        setIsEditMode(false);
        setMealsBeforeEditing(undefined);
        setTemplateBeforeEditing(undefined);
    };
    const resetMealsAndTemplate = () => {
        //Even though SET_TEMPLATE sets the meals, we have to call SET_MEALS after so the selected recipes are maintained
        dispatch({ type: ActionTypes.SET_TEMPLATE, payload: templateBeforeEditing });
        dispatch({ type: ActionTypes.SET_MEALS, payload: mealsBeforeEditing });
    };
    return (_jsx(OrderSummaryEditContext.Provider, Object.assign({ value: {
            mealsBeforeEditing,
            setMealsBeforeEditing,
            templateBeforeEditing,
            setTemplateBeforeEditing,
            isEditMode,
            setIsEditMode,
            isCustomizeModalOpen,
            setIsCustomizeModalOpen,
            recipeId,
            setRecipeId,
            date,
            setDate,
            loading,
            setLoading,
            resetContext,
            resetMealsAndTemplate,
        } }, { children: children })));
};
